import React from 'react';
import StandardAppLayout from 'src/shared/components/layout/standard-app-layout/StandardAppLayout';
import AccessDeniedImage from 'src/assets/images/general/access-denied.webp';

const AccessDenied = () => {
    const mainContent = (
        <div className='container mx-auto p-4'>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                <div className='flex flex-col justify-center text-primary'>
                    <h1 className='text-6xl font-bold mb-6'>Access Denied</h1>
                    <h2 className='text-4xl font-bold mb-4'>You do not have permission to view this page.</h2>
                    <p className='text-xl'>Please contact NatureMetrics support if you believe this is an error.</p>
                </div>
                <div className='flex justify-center items-center'>
                    <img src={AccessDeniedImage} alt='Access denied' />
                </div>
            </div>
        </div>
    );

    return <StandardAppLayout mainContent={mainContent} />;
};

export default AccessDenied;
